import React, { PureComponent } from "react";
import { Col } from "reactstrap";
import { Field, reduxForm } from "redux-form";
import PropTypes from "prop-types";
import renderSelectField from "../../../../shared/components/form/Select";
import * as configs from "./config";

class HorizontalForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  state = {
    inputs: configs.columnHeader,
  };

  componentDidMount() {
    this.props.initialize(this.props.edit());
    this.setState(this.props.edit(), () => this.props.handleForm(this.state));
    this.useCaseRef = React.createRef();
    this.tagRef = React.createRef();
  }

  cancelCreation = () => {
    this.props.reset();
    this.props.cancelCreation();
  };

  formChangeHandler = (event) => {
    let nam = event.target.name;
    let val = event.target.value;

    this.setState({ [nam]: val }, () => {
      this.props.handleForm(this.state);
    });
  };

  getOptions = (key) => {
    switch (key) {
      case "type":
        return this.state.types;
      case "location":
        let locations = [];
        this.state.locations.forEach((location, index) => {
          locations.push({ value: location.id, label: location.name });
        });
        return locations;
      default:
        return [];
    }
  };

  printInput = (input) => {
    switch (input.key) {
      case "type":
        return (
          <Field
            name={input.key}
            component={renderSelectField}
            options={this.getOptions(input.key)}
          />
        );
      default:
        return (
          <Field
            name={input.key}
            component="input"
            type="text"
            placeholder={input.name}
            onKeyUp={this.formChangeHandler}
            value={this.state[input.key]}
          />
        );
    }
  };

  render() {
    const { handleSubmit } = this.props;

    return (
      <Col md={12} lg={12}>
        <div className="card__title">
          <h5 className="bold-text">{this.props.title}</h5>
        </div>
        <form autoComplete="off" className="form form--horizontal" onSubmit={handleSubmit}>
          {this.state.inputs.map((input) =>
            !input.system &&
            (this.props.edit().id === undefined ||
              (this.props.edit().id !== undefined && input.key !== "id")) ? (
              <div className="form__form-group">
                <span className="form__form-group-label">{input.name}</span>
                <div className="form__form-group-field">
                  {this.printInput(input)}
                </div>
              </div>
            ) : (
              ""
            )
          )}
        </form>
      </Col>
    );
  }
}

export default reduxForm({
  form: "proxy_website_form", // a unique identifier for this form
})(HorizontalForm);
